import type { AccountSource } from '../store/schema/AccountSourceList';
import getAccountSourceListStore from '../store/accountSourceListStore';
import getAccountBySourceId from './getAccountBySourceId';

export default function getSelectedAccount(): AccountSource | undefined {
    return getAccountBySourceId(getAccountSourceListStore().selectedSourceId);
}
